import { useCallback, useState } from 'react'
import useFilters from './useFilters'
import { convertCamelToSnake } from '../utils/helpers'
import useSearchParams from './useSearchParams'

const useStatData = (initialIndicator = 'forms') => {
  const urlParams = useSearchParams()
  const [selectedIndicator, setSelectedIndicator] = useState(urlParams.get('indicator') || initialIndicator)
  const { onFilter, initialFilters, results } = useFilters(
    `/admin/v1/stats/${convertCamelToSnake(initialIndicator)}_section.json`
  )

  const fetchFilteredData = useCallback(
    filters => {
      onFilter(filters)
    },
    [onFilter]
  )

  const changeIndicator = indicator => {
    setSelectedIndicator(indicator)
  }

  return {
    selectedIndicator,
    changeIndicator,
    initialFilters,
    results,
    fetchFilteredData
  }
}

export default useStatData
